/*
 * @Description: 神策埋点统一上报工具集
 * @FilePath: /utils/sensors.js
 */

import logger from '@/utils/client-logger';

/**
 * @desc 获取神策实例
 * @returns {object} sensors 实例
 */
export const getSensors = () => {
  if (window.sensors) {
    return window.sensors;
  }

  if (window.sensorsDataAnalytic201505) {
    return window.sensorsDataAnalytic201505;
  }

  if (window.parent.sensors) {
    return window.parent.sensors;
  }

  if (window.parent.sensorsDataAnalytic201505) {
    return window.parent.sensorsDataAnalytic201505;
  }
  return {};
};

/**
 * @desc 普通埋点上报
 * @param {string} eventName 事件名称
 * @param {object} params 事件参数
 */
export const sensorsTrack = (eventName, params = {}) => {
  try {
    const sensors = getSensors();

    // 检查 sensors 是否可用
    if (!sensors.track || typeof sensors.track !== 'function') {
      logger.warn('Sensors track method is not available');
      return;
    }

    const _params = {};

    // 根据标准：只要是值为 '', null, undefined, 'null', 'undefined', []
    Object.keys(params).forEach((key) => {
      const v = params[key];
      if (
        v !== '' &&
        v !== 'null' &&
        v !== 'undefined' &&
        v !== null &&
        v !== undefined &&
        !(v instanceof Array && !v.length)
      ) {
        _params[key] = v;
      }
    });

    sensors.track(eventName, _params);
  } catch (error) {
    logger.error('Sensors track error:', error);
  }
};

/**
 * @desc 神策登录事件
 * @param {string} uuid 用户唯一标识
 */
export const sensorsLogin = (uuid) => {
  try {
    const sensors = getSensors();

    // 检查 sensors 是否可用
    if (!sensors.login || typeof sensors.login !== 'function') {
      logger.warn('Sensors login method is not available');
      return;
    }

    if (uuid === sensors?.store?.getDistinctId()) return;

    if (uuid) {
      sensors.login(uuid);
    }
  } catch (error) {
    logger.error('Sensors login error:', error);
  }
};

/**
 * @desc 神策埋点，用户登出事件
 */
export const sensorsLogout = () => {
  try {
    const sensors = getSensors();

    // 检查 sensors 是否可用
    if (!sensors.logout || typeof sensors.logout !== 'function') {
      logger.warn('Sensors logout method is not available');
      return;
    }

    // sensors.logout();

    // 检查 setProfile 方法是否可用
    if (sensors.setProfile && typeof sensors.setProfile === 'function') {
      sensors.setProfile({ pub_is_login: false });
    }
  } catch (error) {
    logger.error('Sensors logout error:', error);
  }
};

/**
 * @desc 检查 sensors 是否已初始化
 * @returns {boolean} 是否可用
 */
export const isSensorsAvailable = () => {
  const sensors = getSensors();
  return sensors && Object.keys(sensors).length > 0;
};
